import { useState, useEffect } from "react"
import { db } from "../data/firebase"
import { collection, onSnapshot, query, orderBy, deleteDoc, doc } from "firebase/firestore"


export default function DriveChart({user})
{
  const [ drives, setDrives ] = useState(null);

  useEffect(() =>
  {
    if (!user)
      {
        return (
          <div id='main-bg'>
        <p className="tab-button"> loading</p>
        </div>
        )
      }

    const q = query(collection(db, "public"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => 
    {
      const list = snapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));
      setDrives(list);
    });

    return () => unsubscribe();
  }, [setDrives]);

  async function handleTrash(item)
  {
    try
    {
      await deleteDoc(doc(collection(db, "public"), item.id));
    }
    catch(error)
    {
      console.error('Error deleting in firebase,', error);
    }
  }

  return(
    <main>
    <section >
     <table className="tab-button" border="1">
      <thead>
        <tr>
          <th>From</th>
          <th>To</th>
          <th>Reward</th>
        </tr>
      </thead>
      <tbody>
        {drives?
        drives.map((item, index) => (
          <tr key={index}>
            <td>{item.from}</td>
            <td>{item.to}</td>
            <td>${item.price}</td>
            <button className="tab-button" onClick={() => handleTrash(item)}>Trash</button>
          </tr>
        ))
      : <p>loading...</p>}
      </tbody>
     </table>
      </section>
      </main>
  );
}
  
 